import { GlobalStore, ZustandAPI } from './globalStore';
import { EVENT_STATUS_TYPE } from '../utils/types';

type Entity = {
  schedule: {
    dailyTime: string;
    endTime: string;
    scheduledTime: string;
    startTime: string;
    type: 'single' | 'weekly';
    weekdays: string[];
  };
  status?: EVENT_STATUS_TYPE;
  title?: string;
  privacy?: {
    embed: 'private' | 'public' | 'whitelist';
    view:
      | 'anybody'
      | 'contacts'
      | 'disable'
      | 'nobody'
      | 'password'
      | 'ptv'
      | 'ptvhide'
      | 'stock'
      | 'stock_purchased'
      | 'unlisted'
      | 'users'
      | 'embed_only';
  };
  duration?: number;
  thumbnailUrl?: string;
};

export type EntityStore = {
  entity: Entity;
  setEntity: (entity: Entity) => void;
};

export const entityStore = (args: ZustandAPI): EntityStore => {
  const { set, get } = args;
  const entity = initializeState(get);

  return {
    entity: entity,
    setEntity: (entity: Entity) => set(() => ({ entity })),
  };
};

const initializeState = (get: () => GlobalStore): Entity => {
  const lead = get()?.entity;
  if (lead) {
    return lead;
  }
  return {
    schedule: {
      startTime: '',
      endTime: '',
      type: 'single',
      dailyTime: '',
      scheduledTime: '',
      weekdays: [],
    },
  };
};
